<template>
  <div>
    <v-container grid-list-xl fluid>
      <div v-if="alerta">
        <alert-empty></alert-empty>
      </div>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <!-- TABLA CONTINGENCIA-->
            <template>
              <div v-if="loading">
                <loading></loading>
              </div>
              <grid-contingencia :rowsTable="rowsTable"></grid-contingencia>
            </template>
            <!-- TABLA CONTTINGENCIA -->
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import GridContingencia from "@/modules/distribucion/views/contingencia/GridContingencia.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "menu-sub-proceso-impresion",
  components: {
    GridContingencia,
    Loading,
    AlertEmpty,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      text: "En construccion",
      loading: false,
      proveedor: {},
      rowsTable: [20],
      areaValue: "",
      tipoDocumentoValue: "",
      tabs: ["Acuerdo", "Progreso", "Contingencia", "Calidad"],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      itemsDocumento: [],
      nivelSelect: [],
      tipoMaterialSelect: [],
      tipoPruebaSelect: [],
      tipoDocumentoValue: [],
      areaSelect: [],
      nivelValue: null,
      tipoMaterialValue: null,
      tipoPruebaValue: null,
      tipoDocumentoSelect: null,
      areaValue: null,
      filter: false,
      alerta: false,
    };
  },

  mounted() {},

  created() {},
  methods: {},
};
</script>
